const JobTitle = ({ record }) => {
    return <span>Job {record ? `"${record.id}"` : ''}</span>;
};

export default JobTitle;